const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

/**
 * Asynchronously observe changes in the intersection of a target selector
 * @param {string} selector - query selector name
 * @returns
 */
const waitForElm = (selector, base = document) => {
  return new Promise((resolve) => {
    if (base.querySelector(selector)) {
      return resolve(base.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (base.querySelector(selector)) {
        resolve(base.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(base, {
      childList: true,
      subtree: true,
    });
  });
};

const htmlDecode = (input) => {
  let e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes[0].nodeValue;
};

const updateReviews = (product, container, wrapSelector, prefix) => {
  let reviewsContainer = container.querySelector(wrapSelector);
  if (reviewsContainer) {
    reviewsContainer.innerHTML = '';
    let newContainer = document.createElement('div');
    newContainer.classList.add('inline_rating_container');
    newContainer.dataset.bvShow = 'inline_rating';
    newContainer.dataset.bvProductId = product.id;
    newContainer.dataset.bvRedirectUrl = product.url;
    newContainer.setAttribute('id', `BVRRInlineRating${prefix}-${product.id}`);
    reviewsContainer.appendChild(newContainer);
    let stringPid = product.id + '';
    if (window.$BV) {
      $BV.ui('rr', 'inline_ratings', {
        productIds: [stringPid],
        containerPrefix: `BVRRInlineRating${prefix}`,
      });
    }
  }
};

const buildTable = (product, container) => {
  if (
    !document.querySelector(`.size-guide-table[data-guide-id="${product.id}"]`)
  ) {
    container.querySelector('.table-landing').innerHTML += `
      <div class="main-kit-product__size-guide main-product__size-guide" data-guide-id="${product.id}">
        <div class="main-kit-product__size-guide__wrapper">
          <span class="size-guide-toggle close" data-guide-id="${product.id}">
            <svg class="icon icon--close" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="1.80765" y1="0.63601" x2="13.8285" y2="12.6568" stroke="#20170E"/>
              <line x1="1.10055" y1="12.6568" x2="13.1214" y2="0.636008" stroke="#20170E"/>
            </svg>
          </span>
          <h3 data-guide-id="${product.id}">Size Guide</h3>
          <p class="fit-text"></p>
          <div class="overflow-container">
            <span class="overflow"></span>
            <span class="scroll-prompt">Scroll ></span>
            <div class="table-container size-guide__scroller" data-guide-id="${product.id}">
              <table class="size-guide-table" data-guide-id="${product.id}"></table>
            </div>
          </div>
        </div>
      </div>`;
  }
};

const buildCategoryHeading = (productCategory, variantsList) => {
  let categoryHeadingNode = new DOMParser().parseFromString(
    `<div class="variants__color--selected" data-color-category="${productCategory}">
    <p>${productCategory.replaceAll(
      '_',
      ' ',
    )} <span data-product-selected></span></p></div>`,
    'text/html',
  );
  let categoryHeading = categoryHeadingNode.querySelector(
    '.variants__color--selected',
  );
  let categoryWrap = categoryHeadingNode.querySelector('.color-category-wrap');
  variantsList.appendChild(categoryHeading);
};

const buildSizes = (product, guide_id, type) => {
  if (
    document.querySelector(`.size-guide-table[data-guide-id="${guide_id}"]`) ==
    null
  )
    return;
  const sizeTable = document.querySelector(
    `.size-guide-table[data-guide-id="${guide_id}"]`,
  );
  sizeTable.innerHTML = '';
  const backInStockForms = document.querySelectorAll(
    '.main-product__back-in-stock',
  );
  backInStockForms.forEach((form) => {
    form.style.display = 'none';
  });
  const dataType = type == 'regular' ? 'data-product-data' : 'data-product-kit';
  const dataEl = document.querySelector(`[${dataType}]`);
  const data = JSON.parse(dataEl.innerHTML);
  let sizeGuideLocal = [];
  let useLocalSizes = false;

  if (data.sizeGuide == null) {
    useLocalSizes = true;
    sizeGuideLocal = JSON.parse(localStorage.getItem('size_guide'));
  } else {
    window.localStorage.setItem('size_guide', JSON.stringify(data.sizeGuide));
    sizeGuideLocal = data.sizeGuide;
  }

  const isGuide = (element) => {
    if (element.includes('size_guide:')) {
      return true;
    }
    return false;
  };

  let guideIndex = product.tags.findIndex(isGuide);
  let sizeGuideMetafield = product?.size_guide_metafield;

  if (guideIndex !== -1 || sizeGuideMetafield) {
    document.querySelector('.size-guide-toggle').classList.remove('inactive');
    const sizeGuideId = sizeGuideMetafield
      ? sizeGuideMetafield
      : product.tags[guideIndex].replace('size_guide:', '');
    let rowHeaders, selectedSize, sizeValues, rowCount;
    const sizeGuideIndex = sizeGuideLocal.size_guide_id.findIndex(
      (guideName) => guideName === sizeGuideId,
    );
    let tableHtml = '';
    let valuesJson = [];
    const sizeGuideTitle = sizeGuideLocal.size_guide_title[sizeGuideIndex];
    document.querySelector(
      `.main-product__size-guide[data-guide-id="${guide_id}"] h3`,
    ).innerHTML = sizeGuideTitle;
    const sizeGuideFitText = sizeGuideLocal.fit_text[sizeGuideIndex];
    document.querySelector(
      `.main-product__size-guide[data-guide-id="${guide_id}"] .fit-text`,
    ).innerHTML = sizeGuideFitText;
    if (
      sizeGuideLocal.row_headers[sizeGuideIndex] &&
      sizeGuideLocal.size_values[sizeGuideIndex]
    ) {
      rowHeaders = sizeGuideLocal.row_headers[sizeGuideIndex].split('|');
      rowCount = rowHeaders.length;
      sizeValues = sizeGuideLocal.size_values[sizeGuideIndex].split(',');
      selectedSize = product.selectedOrFirstAvailableVariant.option2;
    } else {
      console.log(
        'Sizeguide fields are missed, please check Sizeguide configuration!',
      );
    }

    if (sizeValues) {
      sizeValues.forEach((size, index) => {
        let sizeEntryTemp = size.split('::');
        valuesJson[index] = sizeEntryTemp;
      });
    }
    if (rowHeaders) {
      rowHeaders.forEach((row, index) => {
        let tableRow = '';
        let sizeRow = 0;
        if (sizeGuideLocal.size_row[sizeGuideIndex] != '')
          sizeRow = sizeGuideLocal.size_row[sizeGuideIndex] - 1;
        tableRow += `<tr><th scope="row" class="even row-header">${row}</th>`;
        valuesJson.forEach((value, valueIndex) => {
          const sizeValue = value[sizeRow];
          if (product.optionsWithValues[1].values.includes(sizeValue)) {
            let cell = '';
            cell += `<td class="${valueIndex % 2 != 0 ? `odd` : ``} ${
              sizeValue == selectedSize ? `selected` : ``
            }">${value[index]}${
              index === sizeRow
                ? `<a class="add-size variants__size variants__size--item" style="top: ${
                    index * -104
                  }%;" data-variant-option-value="${
                    value[index]
                  }" data-variant-option-index="option2" data-variant-available="true" data-guide-id="${guide_id}"></a>`
                : ``
            }</td$>`;
            tableRow += cell;
          }
        });
        tableRow += `</tr>`;
        tableHtml += tableRow;
      });

      sizeTable.innerHTML += tableHtml;
    }

    sizeTable.querySelectorAll('.add-size').forEach((sizeLink) => {
      if (type == 'kit') {
        sizeLink.style.top = `${-rowCount * 13}%`;
      }
      sizeLink.style.height = `${rowCount * 103}%`;
      sizeLink.addEventListener('click', (e) => {
        e.preventDefault();
        const addGuideId = sizeLink.dataset.guideId;
        if (
          document.querySelector(
            `.size-guide-table[data-guide-id="${addGuideId}"] td.selected`,
          ) != null
        )
          document
            .querySelector(
              `.size-guide-table[data-guide-id="${addGuideId}"] td.selected`,
            )
            .classList.remove('selected');
        e.currentTarget.parentNode.classList.add('selected');
        let selectedValue = e.currentTarget.dataset.variantOptionValue;
        if (
          document.querySelector(
            `.variants__size[data-size-guide="${addGuideId}"] .variants__size--item.selected`,
          ) != null
        ) {
          document
            .querySelector(
              `.variants__size[data-size-guide="${addGuideId}"] .variants__size--item.selected`,
            )
            .classList.remove('selected');
        }
        document
          .querySelector(
            `.variants__size[data-size-guide="${addGuideId}"] .variants__size--item[data-variant-option-value="${selectedValue}"]`,
          )
          .click();
      });
    });

    if (type != 'kit') {
      document
        .querySelector('.main-product__size-guide button')
        .addEventListener('click', (e) => {
          if (e.currentTarget.hasAttribute('data-drawer-trigger'))
            document
              .querySelector('.main-product__size-guide')
              .classList.remove('active');
        });
    }

    const sizeGuide = document.querySelector('.size-guide__scroller');
    const sizeGuideWrapper = document.querySelector('.overflow-container');
    const overFlow = document.querySelector('.overflow');
    const sizeTableHeight = sizeTable.offsetHeight;
    overFlow.style.height = `${sizeTableHeight}px`;

    sizeGuide.scrollLeft = 0;

    sizeGuide.classList.remove('no-overflow', 'overflowing');
    sizeGuideWrapper.classList.remove('no-overflow', 'overflowing');

    if (sizeGuide.scrollWidth <= sizeGuide.offsetWidth) {
      sizeGuide.classList.add('no-overflow');
      sizeGuideWrapper.classList.add('no-overflow');
    } else {
      sizeGuide.classList.add('overflowing');
    }

    sizeGuide.onscroll = function () {
      let scrollPercent =
        (100 * this.scrollLeft) / (this.scrollWidth - this.clientWidth);
      if (scrollPercent == 0) {
        this.classList.remove('scrolled');
      }
      if (scrollPercent > 0 && scrollPercent < 78) {
        this.classList.add('scrolled');
        this.classList.remove('max-scrolled');
        sizeGuideWrapper.classList.remove('max-scrolled');
      }
      if (scrollPercent > 80) {
        this.classList.add('max-scrolled');
        sizeGuideWrapper.classList.add('max-scrolled');
      }
    };
  } else {
    document.querySelector('.size-guide-toggle').classList.add('inactive');
  }

  const guideToggles = document.querySelectorAll('.size-guide-toggle');
  guideToggles.forEach((guide) => {
    const guideId = guide.dataset.guideId;
    const sizeGuide = document.querySelector(
      `.main-product__size-guide[data-guide-id="${guideId}"]`,
    );
    const sizeGuideBackground = document.querySelector(
      `.main-product__size-guide[data-guide-id="${guideId}"] .main-product__size-guide-modal-bg`,
    );

    sizeGuideBackground.addEventListener('click', (event) => {
      // removed stop prop
      if (
        event.target.classList.contains('main-product__size-guide-modal-bg')
      ) {
        if (guide.classList.contains('close')) {
          sizeGuide.classList.remove('active');
          document.querySelector('body').classList.remove('disable-scroll');
          return;
        } else {
          const sizeScroller = document.querySelector(
            `.size-guide__scroller[data-guide-id="${guideId}"]`,
          );
          sizeScroller.scrollLeft = 0;
          sizeGuide.classList.add('active');
          document.querySelector('body').classList.add('disable-scroll');
        }
      }
    });

    guide.addEventListener('click', (e) => {
      e.preventDefault();
      if (guide.classList.contains('close')) {
        sizeGuide.classList.remove('active');
        document.querySelector('body').classList.remove('disable-scroll');
        return;
      } else {
        const sizeScroller = document.querySelector(
          `.size-guide__scroller[data-guide-id="${guideId}"]`,
        );
        sizeScroller.scrollLeft = 0;
        sizeGuide.classList.add('active');
        document.querySelector('body').classList.add('disable-scroll');
      }
    });
  });
};

module.exports = {
  validateEmail,
  waitForElm,
  htmlDecode,
  updateReviews,
  buildSizes,
  buildTable,
  buildCategoryHeading,
};
